import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute w-dvw h-svh" }
const _hoisted_2 = { class: "absolute top-1 left-1 z-20" }
const _hoisted_3 = { class: "w-full h-full grid grid-cols-1 px-4 pb-4" }
const _hoisted_4 = { class: "flex flex-col gap-y-8 py-4" }
const _hoisted_5 = { class: "flex flex-col gap-y-2 font-bold uppercase text-[1.2em]" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", { class: "flex flex-col gap-y-2 font-bold uppercase text-[1.2em]" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap",
      href: "https://pustkowia.org"
    }, "Pustkowia Winków")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap",
      href: "https://winkonet.pustkowia.org"
    }, "Winko.NET")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "place-self-end flex items-center gap-x-4 whitespace-nowrap uppercase font-bold text-[#12FF15] bg-black/20 px-4 py-2 rounded-[5px]" }, [
  /*#__PURE__*/_createTextVNode("Stronę oraz materiały wykonał Anton Sokolov "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[.2em]" }, "(z drobną pomocą AI)")
], -1)
const _hoisted_8 = {
  id: "Main",
  class: "absolute w-full h-full z-0 isolate px-4 pb-4 pt-[40px]"
}

import { ref } from 'vue';
import MenuIcon from 'vue-ionicons/dist/ios-menu.vue';
import CloseIcon from 'vue-ionicons/dist/ios-close.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isMenuOpen = ref(false);

const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("button", {
        id: "MenuBtn",
        type: "button",
        onClick: toggleMenu,
        class: "flex items-center justify-start px-2 uppercase font-bold h-[40px] rounded-[5px] text-[1.5em]"
      }, [
        (!isMenuOpen.value)
          ? (_openBlock(), _createBlock(MenuIcon, {
              key: 0,
              class: "text-[1.5em]"
            }))
          : (_openBlock(), _createBlock(CloseIcon, {
              key: 1,
              class: "text-[1.5em]"
            })),
        _createTextVNode(" Menu")
      ])
    ]),
    _createElementVNode("div", {
      id: "Menu",
      class: _normalizeClass(["absolute inset-2 z-10 isolate pt-[40px] rounded-[5px] overflow-hidden transition-all duration-1000", {'w-[calc(100%-1em)] h-[calc(100%-1em)]': isMenuOpen.value, 'w-0 h-0': !isMenuOpen.value}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: toggleMenu,
                  class: "text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Strona Główna")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: toggleMenu,
                  class: "text-[#12FF15] hover:text-red-400 transition-colors duration-500 whitespace-nowrap",
                  to: "/map"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mapa (BETA)")
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_6
          ])
        ]),
        _hoisted_7
      ])
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})